import styled from '@emotion/styled';
import Page from '../../layout/Page';
import { keyframes } from '@emotion/react';

const Subscribe:React.FC<any> = () => {
  const handleAddtofriend = () => {
    window.location.href='http://pf.kakao.com/_eiGQK/chat'
  }
  return(
    <>
    <Page disable>
      <Container>
        <ImgContainer>
          <Img src="/images/event/event_2.png"/>
        </ImgContainer>
        <ButtonWrapper>
        <CircularButtonWrapper
        onClick={handleAddtofriend}
        isFixed={true}
        >
        <CircularButton>
          <ButtonText>
            <ImgContainer className='logo'>
              <Img src="/images/kakaologin.png"/>
            </ImgContainer>
          늦기 전에 사진 보내기
          </ButtonText>
        </CircularButton>
          </CircularButtonWrapper>
        </ButtonWrapper>
      </Container>
    </Page>
    </>
  )
}

export default Subscribe;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
  background-color: #fcf7ef;
`;

const ImgContainer = styled.div`
  width: 100%;

  &.logo {
    width: 15px;
    margin-right: 10px;
  }
`;

const Img = styled.img`
  width: 100%;
`


interface ButtonContainerProps {
  isFixed: boolean;
};

interface ButtonContainerProps {
  isFixed: boolean;
};

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #ede3cd;
`;

const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;


const CircularButtonWrapper = styled.div<ButtonContainerProps>`
  width: 90%;
  height: 50px;
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #F9E44D;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  bottom: ${({ isFixed }) => (isFixed ? '20px' : 'auto')};
  margin: ${({ isFixed }) => (isFixed ? '0' : '0 auto')};
  /* margin-bottom: 25px;
  margin-top: 50px; */
  margin: 50px auto 25px;
  animation: ${({ isFixed }) => (isFixed ? slideUp : 'none')} 0.5s ease-in-out;
  display: ${({ isFixed }) => (isFixed ? 'block' : 'none')};
  transition: all 0.5s ease-in-out;
`;

const CircularButton = styled.button`
  width: 100%;
  height: 100%;
  font-weight: bold;
  /* background-color: #e1a349; */
  background-color: #F9E44D;
  color: black;
  border-radius: 40px;
`;

const ButtonText = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`